import { DeclarationType } from "constants/documentTypes";

export const DECLARATION_FIELDS = {
  FED_FEED_CONTAINING_ANIMAL_FATS: "fed_feed_containing_animal_fats",
  OWNED_SINCE_BIRTH: "owned_since_birth",
  OWNED_SINCE_BIRTH_DURATION: "owned_since_birth_duration",
  VETERINARY_TREATMENT: "veterinary_treatment",
  CONSUMED_MATERIAL_IN_WITHHOLDING_PERIOD:
    "consumed_material_in_withholding_period",
  TREATED_WITH_HGP: "treated_with_hgp",
  FED_BYPRODUCT_STOCKFEEDS: "fed_byproduct_stockfeeds",
  CHEMICAL_RESIDUE_RESTRICTIONS: "chemical_residue_restrictions",
  SPRAY_DRIFT_RISK: "spray_drift_risk",
  QA_ACCREDITED: "qa_accredited",
  TREATED_FOR_SCABBY_MOUTH: "treated_for_scabby_mouth",
  POST_BREEDER_TAGS: "post_breeder_tags",
  VETERINARY_TREATMENT_MILK: "veterinary_treatment_milk",
  FEEDLOT_OR_TREATMENT: "feedlot_or_treatment",
  MEETS_HARVESTED_RANGELAND_GOAT_DEFINITION:
    "meets_harvested_rangeland_goat_definition",
  ADDITIONAL_INFORMATION: "additional_information",
};

const DECLARATION_FIELD_LABELS = {
  [DECLARATION_FIELDS.FED_FEED_CONTAINING_ANIMAL_FATS]: "Fats",
  [DECLARATION_FIELDS.OWNED_SINCE_BIRTH]: "VB",
  [DECLARATION_FIELDS.VETERINARY_TREATMENT]: "Vet",
  [DECLARATION_FIELDS.CONSUMED_MATERIAL_IN_WITHHOLDING_PERIOD]: "WHP",
  [DECLARATION_FIELDS.TREATED_WITH_HGP]: "HGP",
  [DECLARATION_FIELDS.FED_BYPRODUCT_STOCKFEEDS]: "Fed Any",
  [DECLARATION_FIELDS.CHEMICAL_RESIDUE_RESTRICTIONS]: "ERP",
  [DECLARATION_FIELDS.SPRAY_DRIFT_RISK]: "Spray",
  [DECLARATION_FIELDS.QA_ACCREDITED]: "QA",
  [DECLARATION_FIELDS.TREATED_FOR_SCABBY_MOUTH]: "Scabby",
  [DECLARATION_FIELDS.POST_BREEDER_TAGS]: "Breeder",
  [DECLARATION_FIELDS.VETERINARY_TREATMENT_MILK]: "Vet Milk",
  [DECLARATION_FIELDS.FEEDLOT_OR_TREATMENT]: "Feedlot",
  [DECLARATION_FIELDS.MEETS_HARVESTED_RANGELAND_GOAT_DEFINITION]: "Rangeland",
  [DECLARATION_FIELDS.ADDITIONAL_INFORMATION]: "Add Info",
};

const SHEEP_DECLARATION_QUESTIONS = {
  1: DECLARATION_FIELDS.QA_ACCREDITED,
  2: DECLARATION_FIELDS.TREATED_FOR_SCABBY_MOUTH,
  3: DECLARATION_FIELDS.OWNED_SINCE_BIRTH,
  4: DECLARATION_FIELDS.VETERINARY_TREATMENT,
  5: DECLARATION_FIELDS.CONSUMED_MATERIAL_IN_WITHHOLDING_PERIOD,
  6: DECLARATION_FIELDS.FED_FEED_CONTAINING_ANIMAL_FATS,
  7: DECLARATION_FIELDS.ADDITIONAL_INFORMATION,
  8: DECLARATION_FIELDS.POST_BREEDER_TAGS,
};

const EU_CATTLE_DECLARATION_QUESTIONS = {
  1: DECLARATION_FIELDS.FED_FEED_CONTAINING_ANIMAL_FATS,
  2: DECLARATION_FIELDS.OWNED_SINCE_BIRTH,
  3: DECLARATION_FIELDS.FED_BYPRODUCT_STOCKFEEDS,
  4: DECLARATION_FIELDS.CHEMICAL_RESIDUE_RESTRICTIONS,
  5: DECLARATION_FIELDS.VETERINARY_TREATMENT,
  6: DECLARATION_FIELDS.CONSUMED_MATERIAL_IN_WITHHOLDING_PERIOD,
  7: DECLARATION_FIELDS.SPRAY_DRIFT_RISK,
  8: DECLARATION_FIELDS.ADDITIONAL_INFORMATION,
};

const CATTLE_DECLARATION_QUESTIONS = {
  1: DECLARATION_FIELDS.TREATED_WITH_HGP,
  2: DECLARATION_FIELDS.FED_FEED_CONTAINING_ANIMAL_FATS,
  3: DECLARATION_FIELDS.OWNED_SINCE_BIRTH,
  4: DECLARATION_FIELDS.FED_BYPRODUCT_STOCKFEEDS,
  5: DECLARATION_FIELDS.CHEMICAL_RESIDUE_RESTRICTIONS,
  6: DECLARATION_FIELDS.VETERINARY_TREATMENT,
  7: DECLARATION_FIELDS.CONSUMED_MATERIAL_IN_WITHHOLDING_PERIOD,
  8: DECLARATION_FIELDS.SPRAY_DRIFT_RISK,
  9: DECLARATION_FIELDS.ADDITIONAL_INFORMATION,
};

const BOBBYCALF_DECLARATION_QUESTIONS = {
  1: DECLARATION_FIELDS.QA_ACCREDITED,
  2: DECLARATION_FIELDS.OWNED_SINCE_BIRTH,
  3: DECLARATION_FIELDS.CONSUMED_MATERIAL_IN_WITHHOLDING_PERIOD,
  4: DECLARATION_FIELDS.VETERINARY_TREATMENT,
  5: DECLARATION_FIELDS.VETERINARY_TREATMENT_MILK,
  6: DECLARATION_FIELDS.CHEMICAL_RESIDUE_RESTRICTIONS,
};

// TODO Remove these after 2025-10-01
const GOAT_DECLARATION_QUESTIONS = {
  1: DECLARATION_FIELDS.OWNED_SINCE_BIRTH,
  2: DECLARATION_FIELDS.FEEDLOT_OR_TREATMENT,
  3: DECLARATION_FIELDS.VETERINARY_TREATMENT,
  4: DECLARATION_FIELDS.CONSUMED_MATERIAL_IN_WITHHOLDING_PERIOD,
  5: DECLARATION_FIELDS.FED_FEED_CONTAINING_ANIMAL_FATS,
};

const UPDATED_GOAT_DECLARATION_QUESTIONS = {
  1: DECLARATION_FIELDS.OWNED_SINCE_BIRTH,
  2: DECLARATION_FIELDS.VETERINARY_TREATMENT,
  3: DECLARATION_FIELDS.CONSUMED_MATERIAL_IN_WITHHOLDING_PERIOD,
  4: DECLARATION_FIELDS.FED_FEED_CONTAINING_ANIMAL_FATS,
  5: DECLARATION_FIELDS.ADDITIONAL_INFORMATION,
};

const HARVESTED_RANGELAND_GOAT_DECLARATION_QUESTIONS = {
  1: DECLARATION_FIELDS.MEETS_HARVESTED_RANGELAND_GOAT_DEFINITION,
};

const DeclarationQuestions = {
  [DeclarationType.S0413]: SHEEP_DECLARATION_QUESTIONS,
  [DeclarationType.S0720]: SHEEP_DECLARATION_QUESTIONS,
  [DeclarationType.C0413]: CATTLE_DECLARATION_QUESTIONS,
  [DeclarationType.C0720]: CATTLE_DECLARATION_QUESTIONS,
  [DeclarationType.E0413]: EU_CATTLE_DECLARATION_QUESTIONS,
  [DeclarationType.E0720]: EU_CATTLE_DECLARATION_QUESTIONS,
  [DeclarationType.BC0720]: BOBBYCALF_DECLARATION_QUESTIONS,
  [DeclarationType.G0720]: GOAT_DECLARATION_QUESTIONS,
  [DeclarationType.G0524]: UPDATED_GOAT_DECLARATION_QUESTIONS,
  [DeclarationType.HG0324]: HARVESTED_RANGELAND_GOAT_DECLARATION_QUESTIONS,
};

export const EuDeclarationVersions = [
  DeclarationType.E0413,
  DeclarationType.E0720,
];

const OPTIONAL_QUESTIONS = [
  DECLARATION_FIELDS.POST_BREEDER_TAGS,
  DECLARATION_FIELDS.ADDITIONAL_INFORMATION,
];

const getDeclarationQuestions = declarationType =>
  DeclarationQuestions[declarationType] || {};

const getDeclarationQuestionFieldByNumber = (declarationType, questionNumber) =>
  getDeclarationQuestions(declarationType)[questionNumber] || null;

const getDeclarationQuestionLabel = questionField =>
  DECLARATION_FIELD_LABELS[questionField] || questionField;

export const getIsDeclarationComplete = declaration => {
  const { VERSION: declarationType } = declaration || {};
  const questions = getDeclarationQuestions(declarationType);
  const requiredFields = Object.values(questions).filter(
    question => !OPTIONAL_QUESTIONS.includes(question),
  );
  if (requiredFields.length === 0) {
    return false;
  }
  return requiredFields.every(field => typeof declaration[field] === "boolean");
};

export const getDeclarationFields = declarationType =>
  Object.values(getDeclarationQuestions(declarationType));

export const getDeclarationQuestionDisplayValue = (
  declarationType,
  questionNumber,
  declaration,
) => {
  if (!declaration) {
    return "";
  }

  const questionField = getDeclarationQuestionFieldByNumber(
    declarationType,
    questionNumber,
  );
  if (!questionField) {
    return "";
  }

  const answer = declaration[questionField];

  if (questionField === DECLARATION_FIELDS.ADDITIONAL_INFORMATION) {
    return answer ? `Info: ${answer}` : "";
  }

  if (answer === null || answer === undefined) {
    return "";
  }

  if (
    questionField === DECLARATION_FIELDS.OWNED_SINCE_BIRTH &&
    answer === false
  ) {
    return `${getDeclarationQuestionLabel(questionField)}: ${declaration[DECLARATION_FIELDS.OWNED_SINCE_BIRTH_DURATION]}`;
  }

  return `${getDeclarationQuestionLabel(questionField)}: ${answer ? "Y" : "N"}`;
};
